import * as React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../tgccGlobal';



const ulStyle:React.CSSProperties = {
    listStyleType:'none',
    width:'160px',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
    display:'flex',
    flexDirection:'column',
    justifyContent:'center'
}
var socialMediaUl = Object.assign({},ulStyle,{alignItems:'center',flexDirection:'row'});
var ulStyle1 = Object.assign({},ulStyle,{});
const licenseUL: React.CSSProperties = {
    listStyleType:'none',
    width:'160px',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
}

const socialLink: React.CSSProperties = {
    textDecoration:'none'
}

const bottomListStyle: React.CSSProperties = {
    textAlign:'center',
    fontFamily:'AveriaSerifItalic',
    width:'90%',
    display:'flex',
    justifyContent:'center'
}

const footerStyles: React.CSSProperties = {
    backgroundColor:'white',
    textAlign:'center',
    lineHeight:'4.2em',
    width:'100%',
    height:'61px',
    fontFamily:'Reitam',
    color:'#616060'
}
const containerDiv: React.CSSProperties = {
    width:'100%',
    marginTop:'75px'
}

const licenseStyle: React.CSSProperties = {
    width:'313px',
    height:'150px'
}
const groupImg: React.CSSProperties = {
    width:'313px'
}
const groupUL: React.CSSProperties = {
    listStyleType:'none',
    color:'#616060',
    cursor:'pointer',
    paddingLeft:'0px',
}
const footerLi: React.CSSProperties = {
    marginBottom:'15px'
}

const liTurnAround: React.CSSProperties = {
    position:'relative',
    top:'19px'
}

const socialMediaIcons: React.CSSProperties = {
    width:'25px'
}
const socialMediaLi: React.CSSProperties = {
    display:'inline-block',
    marginRight:'5px'
}


class _IndigoFooter extends React.Component <Tgcc.BaseProps,any > {

    openFAQ = () => {browserHistory.push(Tgcc.Routes.IndigoFAQ)};
    openContact = () =>{browserHistory.push(Tgcc.Routes.IndigoContact)};
    openShipping = () =>{browserHistory.push(Tgcc.Routes.IndigoShipping)};
    openAbout = () =>{browserHistory.push(Tgcc.Routes.IndigoAbout)}


    getBottomSection(){
        return (
            <div style={bottomListStyle} className="corpFooterCont">
            <ul style={groupUL} className="corpFooterLic">
                    <li><img style={groupImg} src={Tgcc.ResolveUrl('~/images/Footer-01-01.png')} /></li>
                </ul>
                <ul style={ulStyle1} className="corpFooterUl">
                    <li style={footerLi}><i><div onClick={this.openAbout}>About Us</div></i></li>
                    <li style={footerLi}><i><div onClick={this.openContact}>Contact</div></i></li>
                </ul>
                <ul style={socialMediaUl} className="socialMediaUl">
                    <li style={socialMediaLi}><a style={socialLink} href="https://www.facebook.com/IndigoSoftTees/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Facebook.png')} /></a></li>
                    <li style={socialMediaLi}><a href="https://www.instagram.com/indigosofttees/"><img style={socialMediaIcons} src={Tgcc.ResolveUrl('~/images/Instagram.png')} /></a></li>
                </ul>
                <ul style={ulStyle} className="corpFooterUl">
                    <li style={footerLi}><div onClick={this.openFAQ}><i>FAQS</i></div></li>
                    <li style={footerLi}><div onClick={this.openShipping}><i>Turnaround & Returns</i></div></li>

                </ul>
            </div>
        )
    }
    getFooter() {
        const currentYear = new Date().getFullYear();
        return (
            <div style={footerStyles}>
                {`${currentYear} BY THE GRAPHIC COW COMPANY`}
            </div>
        );
    }
    
    render() {
            return (
            <div style={containerDiv} className="corpBottomDiv">
                {this.getBottomSection()}
                {this.getFooter()}
            </div>
        ) 
    }
}


const mapStateToProps = (state: Tgcc.GlobalState, ownProps: Tgcc.BaseProps) => {
    return { state: state};
};
export var IndigoFooter = connect(mapStateToProps)(Radium(_IndigoFooter));

